/**
 * 일부 API 요청 시 startDate를 요구하는데, 기본적으로 세 달 이전을 기준으로 삼습니다.
 * @param monthFrom
 */
import dayjs from 'dayjs';
var getStartDate = function (monthFrom) {
    if (monthFrom === void 0) { monthFrom = 3; }
    return dayjs(Date.now(), 'Asia/Seoul').subtract(monthFrom, 'months').format('YYYYMMDD');
};
export default getStartDate;
